module.exports = __webpack_public_path__ + "fonts/AvenirSemiBold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AvenirSemiBold.woff
// module id = 476
// module chunks = 12